module.exports = __webpack_public_path__ + "ec9bf56ddcb659b46dfdc2abefa9685d.png";